import React from 'react'
import { ReactComponent as GrayLoader } from 'resources/svg/grayLoader.svg'
const ImageLoader = () => {
  return (
    <GrayLoader  className='position-absolute top-50 left-50 transform-center'/>
  )
}

export default ImageLoader